export type Action = SmsProps | CallAction | DelayAction | MmsAction;
export type ActionBase = { id: number; time: string; action: ActionType };

export enum ActionType {
  DELAY = 'delay',
  SMS = 'sms',
  CALL = 'call',
  MMS = 'mms',
}

export type DelayAction = ActionBase & {
  action: ActionType.DELAY;
};

export type SmsProps = ActionBase & {
  msg_id: string | undefined;
  msg: string | undefined;
  message: string | undefined;
  action: ActionType.SMS;
};

export type CallAction = ActionBase & {
  voicemail_audio_url: string | undefined;
  action: ActionType.CALL;
};

export type MmsAction = ActionBase & {
  action: ActionType.MMS;
  url: string | undefined;
  message: string | undefined;
  msg_id: string | undefined;
};

export interface Day {
  id: number;
  actions: Action[];
}
